import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { role } from '../../reducers/currentUser/currentUser.reducer';
import { AdminApp } from '../Admin/AdminApp/AdminApp';
import App from '../App/App';
import { ForemanApp } from '../Foreman/ForemanApp/ForemanApp';
import { ProjectManagerApp } from '../ProjectManager/ProjectManagerApp/ProjectManagerApp';

export const Routes = ({ userRole, ...props }) => (
  <BrowserRouter {...props}>
    <Switch>
      { userRole === 'admin' && <Route path="/admin" component={AdminApp} /> }
      { userRole === 'foreman' && <Route path="/foreman" component={ForemanApp} /> }
      { userRole === 'pm' && <Route path="/pm" component={ProjectManagerApp} /> }
      <Route path="/" component={App} />
    </Switch>
  </BrowserRouter>
);

Routes.propTypes = {
  userRole: PropTypes.string.isRequired,
};

export const mapStateToProps = state => ({
  userRole: role(state),
});

export const mapDispatchToProps = () => ({});

export default (connect(mapStateToProps, mapDispatchToProps)(Routes));



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.jsx